import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Check } from 'lucide-react';
import { Button } from './ui/Button';
export function ProductSection() {
  return <section className="py-20 px-4 pt-[10px] pb-[10px] space-y-[20px]" data-id="element-180">
      <div className="max-w-5xl mx-auto" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[20px] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-183">
            FORMACIÓN EN DETALLADO AUTOMOTOR
            <br data-id="element-184" />
          </h2>

          <p className="md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 text-[16px] font-[300]" data-id="element-185">
            de RENOVA DETAIL
          </p>
        </div>

        <div className="grid md:grid-cols-2 bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-[2.5rem] p-8 md:p-12 border border-gray-800 shadow-2xl relative overflow-hidden bg-[#103806] pt-[7px] pb-[7px] pl-[54px] pr-[54px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] gap-[3px] items-center justify-center" data-id="element-186">
          <div className="absolute top-0 right-0 w-96 h-96 bg-brand-yellow/5 blur-[100px] rounded-full pointer-events-none" data-id="element-187" />

          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative z-10" data-id="element-188">
            <a href="#compra" onClick={e => {
            e.preventDefault();
            document.querySelector('#compra')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-189">
              <div className="relative" data-id="element-190">
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none -z-0" data-id="element-191">
                  <div className="w-[350px] h-[350px] md:w-[500px] md:h-[500px] rounded-full" style={{
                  background: 'radial-gradient(circle, rgba(245, 197, 24, 0.35) 0%, rgba(255, 215, 0, 0.15) 40%, transparent 70%)',
                  filter: 'blur(50px)'
                }} data-id="element-192" />
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/ht7Xjie1z1CFgwShS8pmgZ/Mockup_libro_y_bonos.png" alt="Libro Principal y Bonos" className="w-full max-w-lg mx-auto drop-shadow-[0_20px_50px_rgba(245,197,24,0.2)] hover:scale-105 transition-transform duration-500 cursor-pointer relative z-10" data-id="element-193" />
              </div>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative z-10" data-id="element-194">
            <h3 className="flex gap-4 text-[20px] font-[600] pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[9px] mb-[9px] ml-[0px] mr-[0px] items-center justify-center" data-id="element-195">
              <span className="text-4xl" data-id="element-196">📦</span> QUÉ INCLUYE
            </h3>

            <div className="bg-[#111]/80 backdrop-blur-sm border border-gray-800/60 rounded-xl p-4 mb-6" data-id="element-197">
              <p className="text-sm text-brand-yellow font-black uppercase tracking-widest mb-3" data-id="element-198">
                📖 Libro principal
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-199">
                {['Formación completa en detallado automotor', 'Técnicas paso a paso', 'Proceso profesional real'].map((item, i) => <motion.span key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="inline-flex items-center gap-1.5 bg-green-500/10 border border-green-500/20 text-gray-200 text-sm font-medium px-3 py-1.5 rounded-lg" data-id="element-200">
                    <Check className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-201" />
                    {item}
                  </motion.span>)}
              </div>
            </div>

            <Button className="text-[16px] font-[700] pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[20px] mb-[20px] ml-[0px] mr-[0px] items-center justify-center" data-id="element-202">
              SÍ, QUIERO LA OFERTA AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}